module.exports = __webpack_public_path__ + "static/media/Questionnaire.d91f0f1c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Questionnaire.svg
// module id = 944
// module chunks = 0